import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getOutOfStockProducts } from '../../actions/outOfStockAction';
import Spinner from '../Spinner';

interface Product {
  _id: string;
  name: string;
  image: string;
  category: string;
}

const OutOfStock = ({ outOfStock, getOutOfStockProducts }: any) => {
  useEffect(() => {
    getOutOfStockProducts();
  }, []);

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Out of Stock</p>
        {outOfStock.products.length > 0 && (
          <span className="admin-badge admin-badge-warning">{outOfStock.products.length}</span>
        )}
      </div>

      <div className="admin-card-body">
        {outOfStock.loading && (
          <div className="text-center py-4">
            <Spinner />
          </div>
        )}

        {!outOfStock.loading && outOfStock.products.length === 0 && (
          <div className="admin-empty-state">
            <i className="fas fa-check-circle" />
            <p>All products in stock</p>
          </div>
        )}

        {!outOfStock.loading && outOfStock.products.map((p: Product) => (
          <div key={p._id} className="top-product-row">
            {p.image && (
              <img src={p.image} alt={p.name} className="top-product-img" />
            )}
            <div className="top-product-info">
              <p className="top-product-name">{p.name}</p>
              <p className="out-of-stock-category">{p.category}</p>
            </div>
            <span className="out-of-stock-badge">Out of stock</span>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  outOfStock: state.outOfStock,
});

export default connect(mapStateToProps, { getOutOfStockProducts })(OutOfStock);
